<template>
  <BaseForm
    class="mt-3 mt-md-4 property-contact-form"
    v-bind="formSettings"
    gtm-submit-event="form_submit_property-contact"
  >
    <template #fields>
      <input name="reference" type="hidden" :value="itemId" />

      <NameField
        background-color="rgba(255, 255, 255, 0.10)"
        placeholder="Nome"
        hide-details
        height="48px"
        dark
        solo
      />
      <TelField
        background-color="rgba(255, 255, 255, 0.10)"
        placeholder="Telefone"
        hide-details
        height="48px"
        dark
        solo
      />
      <EmailField
        background-color="rgba(255, 255, 255, 0.10)"
        placeholder="E-mail"
        hide-details
        height="48px"
        dark
        solo
      />
      <MessageField
        background-color="rgba(255, 255, 255, 0.10)"
        placeholder="Mensagem"
        hide-details
        rows="3"
        dark
        solo
      />
      <PolicyPrivacyField hide-details dark solo />
    </template>

    <template #button>
      <ButtonWidget class="mt-3 mt-md-4" color="white" type="submit" block>
        <div class="primary--text">Enviar</div>
      </ButtonWidget>
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import EmailField from "./fields/EmailField.vue";
import TelField from "./fields/TelField.vue";
import MessageField from "./fields/MessageField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _data = {
  formSettings: {
    action: "/rest/email/property-contact",
    responseText:
      "Seu contato foi enviado com sucesso, retornaremos o mais breve possível",
  },
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.split("-").pop();
    },
  },
  components: {
    BaseForm,
    NameField,
    EmailField,
    TelField,
    MessageField,
    PolicyPrivacyField,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.property-contact-form::v-deep {
  .base-form-fields {
    display: grid;
    gap: 15px;
    grid-template-columns: 1fr;
  }

  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-primary-base);
    }

    textarea,
    input {
      &::placeholder {
        color: #ccbec0;
      }
    }
  }
}
</style>
